const compare = require('./compare')
const rcompare = (a, b, loose) => compare(b, a, loose)
module.exports = rcompare



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/rcompare.js
// module id = 2191
// module chunks = 0